import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Feather, LogOut } from "lucide-react";

const NavItem = ({ to, children }) => (
  <NavLink
    to={to}
    data-testid={`nav-${to.replace(/\//g, "") || "home"}`}
    className={({ isActive }) =>
      `link-underline text-sm tracking-wide ${isActive ? "text-[color:hsl(var(--primary))] font-semibold" : "text-[color:hsl(var(--foreground))]"}`
    }
  >
    {children}
  </NavLink>
);

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="w-full border-b border-[hsl(var(--border))] bg-[hsl(var(--background))]/85 backdrop-blur sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] flex items-center justify-center">
            <Feather size={16} />
          </span>
          <span className="font-display text-xl">Humanly</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavItem to="/">Home</NavItem>
          <NavItem to="/pricing">Pricing</NavItem>
          {user && <NavItem to="/dashboard">Dashboard</NavItem>}
          {user && <NavItem to="/history">History</NavItem>}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/profile" data-testid="nav-profile" className="pill">
                <span className="w-5 h-5 rounded-full bg-[hsl(var(--accent))] text-white text-xs flex items-center justify-center">
                  {user.name?.[0]?.toUpperCase() || "H"}
                </span>
                <span className="hidden sm:inline">{user.name}</span>
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => { logout(); nav("/"); }}
                className="btn-ghost text-sm py-2 px-4 flex items-center gap-2"
              >
                <LogOut size={14} /> <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="btn-ghost text-sm py-2 px-4">Login</Link>
              <Link to="/signup" data-testid="nav-signup" className="btn-primary text-sm py-2 px-4">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
